import { Controller } from "@hotwired/stimulus";
import closeCollapse from "../utils/closeCollapse";
import openCollapse from "../utils/openCollapse";

export default class extends Controller {
  connect() {
    this.element.setAttribute("data-tab-ready", true);
  }

  toggle(event) {
    const trigger = event.target.closest('[data-toggle="tab"]');

    const tabs = trigger.closest(".tabs");
    const activeTabTrigger = tabs.querySelector(".tab-nav .active");
    const activeTab = tabs.querySelector(".collapse.open");
    const targetedTab = tabs.querySelector(trigger.dataset.target);

    if (activeTabTrigger === trigger) return;

    // Trigger
    activeTabTrigger.classList.remove("active");
    trigger.classList.add("active");
    closeCollapse(activeTab);
    openCollapse(targetedTab);
  }
}
